import {
  postLogin,
  postLoginMipyme,
  postValidate,
  getUserStatus,
} from '../config/apiSinToken'
/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: SECURITY LOGIN BACKEND NGS
 * FECHA: 30-8-2022
 */
export const LoginBack = async (Email) => {
  const data = await postLogin(`api/v1/Auth/Authentication`, Email, 2)
  return data
}

export const LoginMipyme = async (email) => {
  const data = await postLoginMipyme(`api/v1/Auth/Authentication`, email, 1)
  return data
}
export const ValidateTokenMipyme = async (token) => {
  const data = await postValidate(`api/v1/Auth/ValidateToken`, token)
  return data
}

/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Endpoint que devuelve el estatus del usuarios activo o inactivo un
 * FECHA:3/11/2022
 */
export const ValidateStatusUser = async (userb2c, token) => {
  const data = await getUserStatus(
    `api/v1/Users/StatusUserB2C/${userb2c}`,
    token,
  )
  return data
}
